import { DataTableComp } from "../Common/DataTable";
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import Swal from 'sweetalert2'
import { Link, useSearchParams } from "react-router-dom";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useEffect, useState } from "react";
import axios from "axios";
import { Autocomplete, IconButton, Tooltip, TextField } from "@mui/material";
import {RatersList} from "./RatersList";
import { Delete, Edit } from '@mui/icons-material';
import AssessmentIcon from '@mui/icons-material/Assessment';
var moment = require('moment');

export default function Assessments() {
    // const authUser = localStorage.getItem('FF-authUser');
    // const user = JSON.parse(authUser);
    const [searchParams, setSearchParams] = useSearchParams();
    const [subjects, setSubjects] = useState([]);
    const [assessments, setAssessments] = useState([]);
    const [assessmentList, setAssessmentList] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [teamId, setTeamId] = useState(0);
    const [selectedOrganization, setSelectedOrganization] = useState(null)
    const [raters, setRaters] = useState([]);
    const [assessmentSentAt, setAssessmentSentAt] = useState(null);
    const [show, setShow] = useState(false);
    const [subject, setSubject] = useState({})

    useEffect(() => {
        init()        
    }, [])

    const init = () => {
        getOrganizations()
        getSubjects()
        let id = searchParams.get('id')
        let name = searchParams.get('name')
        if(id > 0 && name !== ''){
            setSelectedOrganization({id: id, name: name})
            setTeamId(id)
            getListForDropdown(id)
            getAssessments(id)
        }
        else{
            setSelectedOrganization(null)            
            getListForDropdown()
            getAssessments()
        }
    }

    const getOrganizations = () => {
        axios.get(`/api/teams`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setOrganizations(result.data)
            }
        })
    }

    const getSubjects = () => {
        axios.get(`/api/subjects`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setSubjects(result.data)
            }
        })
    }

    const getListForDropdown = (teamId = '') => {
        axios.get(`/api/assessment-list?teamId=${teamId}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setAssessmentList(result.data)
            }
        })
    }

    const getAssessments = (teamId = '', id = '', subjectId = '' ) => {
        axios.get(`/api/assessments?teamId=${teamId}&assessmentId=${id}&subjectId=${subjectId}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setAssessments(result.data)
                console.log("assessments",assessments)
            }
        })
    }

    const handleChangeOrganization = (event, value) => {            
        // console.log("Autocomplete value",value)
        if (searchParams.has('id')) {
            searchParams.delete('id');
            searchParams.delete('name');
            setSearchParams(searchParams);               
        }
        if(value && value.id){
            setTeamId(value.id)
            getListForDropdown(value.id)
            getAssessments(value.id)
            setSelectedOrganization(value)
        }
        else{
            getAssessments()
            setTeamId(0)
            setSelectedOrganization(null)
        }
    }

    const handleChangeAssessment = (event, value) => {
        // console.log("Autocomplete value",value)
        if(value && value.id){
            getAssessments('', value.id)
        }
        else{
            getAssessments(teamId)
        }
    }

    const handleChangeSubject = (event, value) => {
        // console.log("Autocomplete value",value)
        if(value && value.id){
            getAssessments('', '', value.id)
        }
        else{
            getAssessments(teamId)
        }
    }

    const showRatersList = (row) => {
        let subject = {
            id: row.id,
            assessmentId: row.assessmentId,
            firstName: row.firstName,
            lastName: row.lastName,
            name: row.firstName+' '+row.lastName,
            email: row.email,
            status: row.assessmentStatus,
            assessmentLink: row.assessmentLink
        }
        setSubject(subject)
        setRaters(row.subject_raters);
        setAssessmentSentAt(row.sentAt);
        setShow(true);
    }

    const generateReport = (subjectId) => {
        axios.post(`api/generateReport`, {subjectId: subjectId}).then(res => {
            if(res.data.success){
                Swal.fire(res.data.message, '', 'success').then(result => {
                })                
            } 
            else{
                Swal.fire(res.data.message, '', 'error')
            }
        }).catch((error) => {
            setShow(false)
            Swal.fire(error.response.data.message, '', 'error')
        });
    }

    const handleDelete = (assessmentId) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            showCancelButton: true,
            confirmButtonColor: '#45a7c4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) { 
                axios.delete(`/api/assessment/delete/${assessmentId}`).then((res) =>{
                    if(res.data.success){                             
                        Swal.fire(res.data.message, '', 'success')
                        init()
                    } 
                }).catch((error) => {
                    console.log(error);                     
                    Swal.fire(error.message, '', 'info')           
                });
            } else if (result.isDenied) {
              Swal.fire('Cancelled!', '', 'info')
            }
        }) 
    }

    const columns = [
        {
            name: 'Subject Name',
            selector: row => (row.firstName ? row.firstName : '')+' '+(row.lastName ? row.lastName : ''),
            cell: row => (
                <span style={{cursor:'pointer',color:'#78bfcc',fontWeight:'700',textDecoration:'underline',textUnderlineOffset:'4px'}} onClick = {()=>showRatersList(row, row.subject_raters, row.sentAt)} >{ (row.firstName ? row.firstName : '')+' '+(row.lastName ? row.lastName : '')}</span>
            ),
            sortable: true,
            // width: '15%'
        },
        {
            name: 'Assessment',
            selector: row => row?.assessment?.name,
            cell: row => (
                row.assessment.sentAt !== null ? 
                <Link style={{cursor:'pointer',color:'#222',fontWeight:'700',textDecoration:'underline',textUnderlineOffset:'4px'}} to={`${row.assessment.assessmentLink}&welcome=yes`} target="_blank">{row?.assessment?.name}</Link>
                :
                <Link style={{cursor:'pointer',color:'#78bfcc',fontWeight:'700',textDecoration:'underline',textUnderlineOffset:'4px'}} to={`/create_assessment/${row.assessment.id}`}>{row?.assessment?.name}</Link>
            ),
            sortable: true,
            // width: '15%'
        }, 
        {
            name: 'Organization',
            selector: row => row?.assessment?.team?.name,
            sortable: true,
            // width: '15%'
        },
        {
            name: 'Sent Date',
            selector: row => row?.assessment?.sentAt,
            cell: row => (
                <label>{row?.assessment?.sentAt ? moment(row.assessment.sentAt).format('MM/DD/YYYY'): '-'}</label>
            ),
            sortable: true,
            // width: '10%'
        },
        {
            name: 'Self Status',
            cell: row => (
               <Stack spacing={1} alignItems="center">                   
                    <Stack direction="row" spacing={1}>
                    {
                        row.assessmentStatus === 'Done' ? 
                        <Chip label="Done" color="success" size="small" />                        
                        :
                        <Chip label="Pending" color="info" size="small" variant="outlined" />
                    }   
                    </Stack>
                </Stack>            
            ),
        },        
        {
            name: 'No of Raters',
            cell: row => (
                <span>
                    {row.subject_raters ? row.subject_raters.filter(entry => entry.status === "1").length : 0} / {row.subject_raters ? row.subject_raters.length : 0}
                </span>
            ),
            // sortable: true,
            // width: '10%'
        },
        {
            name: 'Status',
            cell: row => (
               <Stack spacing={1} alignItems="center">                   
                    <Stack direction="row" spacing={1}>
                        {
                            row.assessment.status === 'Completed' ? 
                            <Chip label="Completed" color="success" size="small" />
                            : row.assessment.status === 'Pending' ? 
                            <Chip label={row.assessment.status} color="warning" size="small" variant="outlined" />
                            : <Chip label={row.assessment.status} color="info" size="small" variant="outlined" />
                        }
                    {/* {
                        row.assessmentStatus === 'Done' && row.subject_raters.length === row.subject_raters.filter(entry => entry.status === "1").length ? 
                        <Chip label="Completed" color="success" size="small" />
                        :
                        <Chip label={row.assessment.status} color="info" size="small" variant="outlined" />
                        
                    }    */}
                    </Stack>
                </Stack>            
            ),
        },
        // {
        //     name: 'Rater Response',
        //     cell: row => row.subject_raters ? row.subject_raters.filter(entry => entry.status === "1").length : 0,
        //     width: '12%'
        // },
        // {
        //     name: 'Rater Totals',
        //     cell: row => (
        //         <span style={{cursor:'pointer',color:'#78bfcc',fontWeight:'700',textDecoration:'underline',textUnderlineOffset:'4px'}} onClick = {()=>showRatersList(row.subject_raters, row.sentAt)} >{row.subject_raters ? row.subject_raters.length : 0}</span>
        //     ),
        //     width: '10%'
        // },         
        // {
        //     name: 'Template',
        //     selector: row => row.assessment_survey?row.assessment_survey.name:'N/A',
        //     sortable: true,
        // },        
        {
            name: 'Action',
            cell: row => (
                row.canReportGenerate === '1' && row.isReportGenerated === '0' ? 
                <>
                    <Tooltip onClick={() => generateReport(row.id)} title="Generate Report" size='small' className='icon icon-sm icon-secondary'>
                        <IconButton>
                            <AssessmentIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip onClick = {()=>showRatersList(row, row.subject_raters, row.sentAt)} title="Edit" size='small' className='icon icon-sm icon-secondary ms-2'>
                        <IconButton>
                             <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip onClick={() => handleDelete(row.assessment.id)} title="Delete" size='small' className='icon icon-sm icon-primary ms-2'>
                        <IconButton>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </>
                : row.assessment.status === 'Pending' ?
                <>                    
                    <Tooltip onClick = {()=>showRatersList(row, row.subject_raters, row.sentAt)} title="Edit" size='small' className='icon icon-sm icon-secondary'>
                        <IconButton>
                             <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip onClick={() => handleDelete(row.assessment.id)} title="Delete" size='small' className='icon icon-sm icon-primary ms-2'>
                        <IconButton>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </> 
                : 
                <Tooltip onClick={() => handleDelete(row.assessment.id)} title="Delete" size='small' className='icon icon-sm icon-primary ms-2'>
                    <IconButton>
                        <Delete />
                    </IconButton>
                </Tooltip>
            )
        }
        // {
        //     name: 'Send reminder to all incomplete',
        //      cell: row => (
        //         row.status === '1' ? 
        //        <span className='icon icon-sm icon-secondary' style={{cursor:'pointer'}} onClick = {()=>sendBulkReminder(row.assessment_subject)}><span className="bx b bx-paper-plane"></span></span> 
        //         : 
        //         <span className='icon icon-sm icon-secondary' style={{cursor:'pointer'}}  onClick = {()=>Swal.fire('The assessment has not been sent yet!')}><span className="bx b bx-paper-plane"></span></span>        
        //     )
        // },          
    ];

    return(
        <Layout>
            <Header pageTitle="Assessments" />
            <div className="container-xxl flex-grow-1 container-p-y">            
                <div className="">
                    <div className="card-header ">
                        <div className="row align-items-center">                    
                            <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-Rg-3">
                                <h3 className="fw-bold mb-0">Assessments</h3>
                            </div> 
                            <div className="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-Rg-3">
                                 <Autocomplete
                                    id="combo-box-demo-org"
                                    sx={{ width: 'auto' }}
                                    size='small'
                                    options={organizations}
                                    getOptionLabel={(option) => option.name}
                                    onChange={handleChangeOrganization}
                                    value={selectedOrganization}
                                    renderInput={(params) => <TextField {...params} label={"Select Organization"} />}
                                    
                                />
                            </div>
                            <div className="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-Rg-3">
                                 <Autocomplete
                                    id="combo-box-demo-assessment"
                                    sx={{ width: 'auto' }}
                                    size='small'
                                    options={assessmentList}
                                    getOptionLabel={(option) => option.name}
                                    onChange={handleChangeAssessment}
                                    // value={selectedOption}
                                    renderInput={(params) => <TextField {...params} label={"Select Assessment"} />}
                                    
                                />
                            </div>
                            <div className="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-Rg-3">
                                 <Autocomplete
                                    id="combo-box-demo-subject"
                                    sx={{ width: 'auto' }}
                                    size='small'
                                    options={subjects}
                                    getOptionLabel={(option) => option.firstName+' '+option.lastName}
                                    onChange={handleChangeSubject}
                                    // value={selectedOption}
                                    renderInput={(params) => <TextField {...params} label={"Select Subject"} />}
                                    
                                />
                            </div>                           
                            <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12 text-md-end">                                
                                <Link to='/create_assessment' type="button" className="btn btn-primary mb-Rg-3">
                                    <span className="tf-icons bx b bx-paper-plane"></span>&nbsp; Create Assessment
                                </Link>                                
                            </div>                           
                        </div>                        
                    </div>
                    <div className="table">
                        <div className="">
                            <DataTableComp columns={columns} data={assessments} />                            
                        </div>
                    </div>
                </div>
            </div> 
            <RatersList subject={subject} raters={raters} show={show} setShow={setShow} assessmentSentAt={assessmentSentAt} init={init}/>                                             
        </Layout>
    )
}